/**
 * GenerateResponseAction Component
 * Action chip for generating AI responses based on SELECTED MESSAGES
 * Executes directly on click (no language dropdown).
 *
 * Usa ActionChip para herdar o mesmo padrao visual da Traduzir/Chamar Agente
 * — em particular as cores do estado desativado. Antes essa acao tinha
 * estilos proprios e ficava cinza diferente das outras quando indisponivel.
 */
import React from 'react';
import { Sparkles } from 'lucide-react';
import ActionChip from '../ActionChip';
import { ACTION_TYPES, ACTIONS_CONFIG } from '../constants';

const GenerateResponseAction = ({
  onExecute,
  isProcessing = false,
  isDisabled = false,
  disabledReason = 'Selecione mensagens para gerar resposta',
}) => {
  const config = ACTIONS_CONFIG[ACTION_TYPES.GENERATE];

  const handleClick = () => {
    if (isDisabled || isProcessing) return;
    onExecute?.();
  };

  return (
    <ActionChip
      icon={Sparkles}
      label={config.label}
      isActive={false}
      isDisabled={isDisabled}
      isProcessing={isProcessing}
      processingLabel="Gerando..."
      hasDropdown={false}
      onClick={handleClick}
      tooltip={isDisabled ? disabledReason : null}
    />
  );
};

export default GenerateResponseAction;
